export const Seprator = () => {
  return (
    <div className="flex items-center justify-center w-full">
      <div className="flex-grow border-t border-base-border"></div>
      <div className="text-muted-foreground text-sm weight-normal pr-2 pl-2"> Or pay another way</div>
      <div className="flex-grow border-t border-base-border" />
    </div>
  );
};
